module.exports = "/_next/static/images/Hero-6f397bf4f3f5a880021ffcdad61ba9bd.webp";